import cplook from 'cplook'

$( ->
  if $('#system-status').length > 0
    $.ajax
      url: '/system_status',
      success: (data) ->
        $('#system-status').append(data)

  if $('.open-print').length > 0
    if /chrome/i.test( navigator.userAgent )
      the_modal = window.get_modal_markup()
      the_modal.html(window.get_modal_content(
        'Ready to Print',
        "<p>This page is now formatted for printing. " +
          "You may now use your browser's print function to print this page.",
        '<button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>'
      ))
      the_modal.modal()
      setTimeout ->
        the_modal.modal('hide')
      , 5000
    else
      $(window).on 'load', ->
        window.print()

  enable_toolpops = (parent)->
    if $(window).width() > cplook.mobilePivot
      parent.find('.has-tooltip').tooltip({ container: 'body', html: true })
    parent.find('.has-popover').popover({ container: 'body', html: true })

  enable_toolpops($(document))

  $(document).on 'show.bs.modal', '.modal', (e)->
    enable_toolpops($(this))

  $(document).on 'click', 'a.disabled', (ev)->
    ev.preventDefault()
    return false

  $(document).on 'focus', '.replacement', ->
    if $(this).val() == $(this).attr('data-prompt')
      $(this).val('')
    if $(this).hasClass('blank')
      $(this).removeClass('blank')

  $(document).on 'blur', '.replacement', ->
    if $(this).val() == ''
      $(this).val($(this).attr('data-prompt'))
      $(this).addClass('blank')
  $('.replacement').blur()

  $(document).on 'ajax:before', 'form', ->
    $(this).find('.replacement').each ->
      if $(this).val() == $(this).attr('data-prompt')
        $(this).val('')

  # TODO: CP-6243 Still used by app/views/manage/eeoc/index.html.erb
  $(document).on 'click', 'a.update_settings', (ev)->
    ev.preventDefault()
    $.ajax({
      url: '/manage/account/update_setting',
      type: "PATCH",
      data: { name: $(this).data('name'), value: $(this).data('value') }
    })
    false

  $(document).on 'change', 'input.update_settings', (ev)->
    ev.preventDefault()
    data = { name: $(this).attr('name') }
    if $(this).attr('type') == 'checkbox'
      if $(this).prop('checked')
        data.value = 1
      else
        data.value = 0
    else
      data.value = $(this).data('value')
    $.ajax({
      url: '/manage/account/update_setting',
      type: "PATCH",
      data: data
    })
    false

  $(document).on 'change', 'input.update_account', (ev)->
    ev.preventDefault()
    data = {}
    n = $(this).attr('name')
    if $(this).attr('type') == 'checkbox'
      if $(this).prop('checked')
        data[n] = 1
      else
        data[n] = 0
    else
      data[n] = $(this).val()
    $.ajax({
      url: '/manage/account.js',
      type: "PATCH",
      data: { account: data }
    })
    false

  $('.nav.buttons a.disabled').click ->
    return false

  if $('.user-association-management-select2').length > 0
    $('.user-association-management-select2').select2({
        theme: "bootstrap"
    })
)
